<template>
  <div>
    <!-- 活动列表配置 -->
    <div>
      <h4 class="describe">活动列表</h4>
      <div class="activityListWrap">
        <h6 class="tips">活动配置</h6>
        <p class="careful">此处显示所有未开始或进行中的积分任务活动</p>
        <!-- 配置表格 -->
        <configTable
          :configHead="configHead"
          :configList="pageConfig.integralTask.activityList"
          :notDesc="false"
        ></configTable>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import PhotoGallery from "@/components/PhotoGallery";
import LInkAdmin from "@/components/LInkAdmin";
import selectPictureMiXin from "@/mixin/selectPictureMiXin";
import configTable from "../configTable";
export default {
  components: {
    PhotoGallery,
    LInkAdmin,
    configTable,
  },
  data() {
    return {
      photoGalleryVisible: false,
      linkAdminVisible: false,
      configHead: [
        { name: "活动名称", flex: 2 },
        { name: "状态", flex: 2 },
        { name: "图标", flex: 1 },
        { name: "排序", flex: 1 },
        { name: "操作", flex: 1 },
      ],
      configList: [],
    };
  },
  mounted() {
    this.pageConfig.integralTask.activityList.forEach((item, index) => {
      if (item.status == 3) {
        this.pageConfig.integralTask.activityList.splice(index, 1);
      }
    });
  },

  computed: {
    ...mapState(["pageConfig"]),
  },
  mixins: [selectPictureMiXin],
  methods: {
    ...mapMutations([
      "movePower",
      "handleVisibility",
      "replaceIcon",
      "checkCurLinkItem",
      "editItemLink",
    ]),
    // 选择链接后返回
    linkAdminChange(data) {
      this.linkAdminVisible = false;
      if (data) {
        //有数据返回
        this.editItemLink(data);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.describe {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  padding-left: 28px;
  margin: 0;
  text-align: left;
  height: 64px;
  background-color: #f5f5f5;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  .desc {
    margin-top: 5px;
    color: #999;
    font-size: 14px;
    font-weight: 400;
  }
}
.activityListWrap {
  box-sizing: border-box;
  padding: 20px 28px;
  text-align: left;
  border-bottom: 1px solid #f3f3f3;
  .tips {
    position: relative;
    display: inline-block;
    color: #333;
    font-size: 14px;
    font-weight: 500;
    &::after {
      content: "*";
      position: absolute;
      right: -8px;
      top: 2px;
      color: #ff3a27;
    }
  }
  .careful {
    margin-top: 6px;
    color: #333;
    font-size: 14px;
    font-weight: 400;
  }
  .configTable {
    margin-top: 20px;
    .configTh {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 30px;
      height: 50px;
      background-color: #fafafa;
      span {
        color: #333;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .configItem {
      box-sizing: border-box;
      padding: 16px 30px 20px;
      border-bottom: 1px solid #f3f3f3;
      &:last-child {
        border: none;
      }
      .edit {
        display: flex;
        align-items: center;
        .ipt {
          flex: 3;
          height: 32px;
          /deep/ .el-input__inner {
            width: 90%;
            height: 32px;
          }
        }
        .icons {
          flex: 1;
          height: auto !important;
          img {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            cursor: pointer;
          }
        }
        .sort {
          flex: 1;
          i {
            cursor: pointer;
            &.disabled {
              color: #dddddd;
              cursor: no-drop;
            }
          }
        }
        .eye {
          flex: 1;
          cursor: pointer;
          .visible {
            color: #ccc;
          }
        }
      }
      .link {
        position: relative;
        margin-top: 16px;
        .jumpLink {
          position: absolute;
          right: 1px;
          top: 1px;
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background-color: #eeeeee;
          cursor: pointer;
        }
        .linkIpt {
          height: 32px;
          /deep/ .el-input__inner {
            height: 32px;
          }
        }
      }
    }
    .handle {
      box-sizing: border-box;
      padding-left: 30px;
      margin-top: 16px;
      color: #999;
      font-size: 13px;
      font-weight: 400;
      .add {
        display: inline-block;
        margin-right: 12px;
        cursor: pointer;
        color: #7f85e9;
      }
    }
  }
}
</style>
